'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@/components/ui/app-dropdown-menu';
import { Icon } from '@/components/ui/icon';
import { ArrowDown01Icon } from '@/components/ui/icon/glyphs';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface ChartDropdownItem {
  key: string;
  label: ReactNode;
}
interface ChartDropdownProps {
  items: ReadonlyArray<ChartDropdownItem>;
  active: string;
  onChange: (key: string) => void;
  /** Accessible name for the trigger. */
  ariaLabel?: string;
  /** Content alignment relative to the trigger. */
  align?: 'start' | 'end';
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

/**
 * A single-value dropdown styled to match the `SegmentedControl` `chart`
 * variant: a rounded shell (`bg-background-primary p-1`) wrapping one rounded
 * inner pill (`bg-background-secondary shadow-sm`) showing the active value,
 * with a trailing caret. Used on mobile in place of wide chart segmented
 * controls (interval, chart mode) so the toolbar collapses to a single row.
 */
export function ChartDropdown(t0) {
  const $ = _c(25);
  const {
    items,
    active,
    onChange,
    ariaLabel,
    align: t1
  } = t0;
  const align = t1 === undefined ? "start" : t1;
  let t2;
  if ($[0] !== active || $[1] !== items) {
    let t3;
    if ($[3] !== active) {
      t3 = item => item.key === active;
      $[3] = active;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = items.find(t3);
    $[0] = active;
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activeItem = t2;
  let t3;
  if ($[5] !== ariaLabel) {
    t3 = ariaLabel !== undefined ? {
      "aria-label": ariaLabel
    } : {};
    $[5] = ariaLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = activeItem?.label;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon icon={ArrowDown01Icon} className="size-3.5 text-foreground-secondary transition-transform group-data-[state=open]:rotate-180" aria-hidden="true" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <span className="inline-flex items-center gap-1 rounded-full bg-background-secondary px-2.5 py-1 text-caption font-medium text-foreground-primary shadow-elevation-inset">{t4}{t5}</span>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <DropdownMenuTrigger {...t3} className="group inline-flex shrink-0 items-center rounded-full bg-background-primary p-1 outline-none">{t6}</DropdownMenuTrigger>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== items) {
    t8 = items.map(_temp);
    $[13] = items;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== active || $[16] !== onChange || $[17] !== t8) {
    t9 = <DropdownMenuRadioGroup value={active} onValueChange={onChange}>{t8}</DropdownMenuRadioGroup>;
    $[15] = active;
    $[16] = onChange;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== align || $[20] !== t9) {
    t10 = <DropdownMenuContent align={align}>{t9}</DropdownMenuContent>;
    $[19] = align;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <DropdownMenu>{t7}{t10}</DropdownMenu>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(item_0) {
  return <DropdownMenuRadioItem key={item_0.key} value={item_0.key}>{item_0.label}</DropdownMenuRadioItem>;
}